import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const digits = (v) => String(v || "").replace(/\D/g, "");
const fmtCnpj = (d) => d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
const fill = (edit, data) => Object.fromEntries(Object.entries(data).filter(([k, v]) => v && (!edit.id || !edit[k])));

export async function supplierFromCnpj(value, edit) {
  const d = digits(value);
  if (d.length !== 14) return null;
  try {
    const { data } = await api.get(`/lookup/cnpj/${d}`);
    const { situation, ...rest } = data;
    toast.success(`Dados do CNPJ preenchidos${situation && situation !== "ATIVA" ? ` · situação na Receita: ${situation}` : ""}`);
    return { ...fill(edit, rest), document: fmtCnpj(d) };
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}

export async function addressFromCep(value, edit) {
  const d = digits(value);
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`).then((x) => x.json());
    if (r.erro) { toast.error("CEP não encontrado"); return null; }
    return fill(edit, { street: r.logradouro, district: r.bairro, city: r.localidade, state: r.uf });
  } catch {
    toast.error("Não foi possível buscar o CEP agora");
    return null;
  }
}
